module.exports = __webpack_public_path__ + "static/czesci-wspolne-f07682b8b1fb4ca9780adab31be49338.jpg";